import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
	AddCustomerInput,
	ContactDataInput,
	CreateAddressInput,
	CustomerStateData,
	EditCustomerInput,
	LocationData
} from "~/gql/graphqlBase.generated";

interface CustomerState {
	addCustomerInput?: AddCustomerInput;
	addressFormOpen: boolean;
	contactDataInput?: ContactDataInput;
	contactFormOpen: boolean;
	createAddressInput?: CreateAddressInput;
	createLocationInput?: LocationData;
	customerStateData?: CustomerStateData;
	editCustomerInput?: EditCustomerInput;
	locationData?: LocationData;
	locationFormOpen: boolean;
}

const initialState: CustomerState = {
	addressFormOpen: false,
	contactFormOpen: false,
	locationFormOpen: false
};

export const customerSlice = createSlice({
	initialState,
	name: "customer",
	reducers: {
		closeAddressForm: (state) => {
			state.addressFormOpen = false;
		},
		closeContactForm: (state) => {
			state.contactFormOpen = false;
		},
		closeLocationForm: (state) => {
			state.locationFormOpen = false;
		},
		openAddressForm: (state) => {
			state.addressFormOpen = true;
		},
		openContactForm: (state) => {
			state.contactFormOpen = true;
		},
		openLocationForm: (state) => {
			state.locationFormOpen = true;
		},
		setContactDataInput: (state, action: PayloadAction<ContactDataInput | null>) => {
			if (action.payload === null) {
				state.contactDataInput = undefined;
				return;
			}
			state.contactDataInput = { ...action.payload };
		},
		setCreateAddressInput: (state, action: PayloadAction<CreateAddressInput | null>) => {
			if (action.payload === null) {
				state.createAddressInput = undefined;
				return;
			}
			state.createAddressInput = { ...action.payload };
		},
		setCreateLocationInput: (state, action: PayloadAction<LocationData | null>) => {
			if (action.payload === null) {
				state.createLocationInput = undefined;
				return;
			}
			state.createLocationInput = { ...action.payload };
		},
		setCustomer: (state, action: PayloadAction<CustomerStateData | null>) => {
			if (action.payload === null) {
				state.customerStateData = undefined;
				state.createLocationInput = undefined;
				state.editCustomerInput = undefined;
				state.addCustomerInput = undefined;
				return;
			}
			state.customerStateData = { ...action.payload };
		},
		updateContactDataInput: (state, action: PayloadAction<Partial<ContactDataInput>>) => {
			if (!action.payload) {
				state.contactDataInput = undefined;
			} else {
				if (!state.contactDataInput) return;
				state.contactDataInput = { ...state.contactDataInput, ...action.payload };
			}
		},
		updateCreateAddressInput: (state, action: PayloadAction<Partial<CreateAddressInput>>) => {
			if (!action.payload) {
				state.createAddressInput = undefined;
			} else {
				if (!state.createAddressInput) return;
				state.createAddressInput = { ...state.createAddressInput, ...action.payload };
			}
		},
		updateCreateLocationInput: (state, action: PayloadAction<Partial<LocationData>>) => {
			if (!action.payload) {
				state.createLocationInput = undefined;
			} else {
				if (!state.createLocationInput) return;
				state.createLocationInput = { ...state.createLocationInput, ...action.payload };
			}
		},
		updateCustomer: (state, action: PayloadAction<Partial<CustomerStateData>>) => {
			if (!action.payload) {
				state.customerStateData = undefined;
			} else {
				if (!state.customerStateData) return;
				state.customerStateData = { ...state.customerStateData, ...action.payload };
			}
		}
	}
});

export const {
	setContactDataInput,
	setCreateAddressInput,
	setCreateLocationInput,
	setCustomer,
	updateContactDataInput,
	updateCreateAddressInput,
	updateCreateLocationInput,
	updateCustomer
} = customerSlice.actions;

export default customerSlice.reducer;
